const initialState = {
	isProfilePage: !!document.getElementById('page_player')
};

export default (state = initialState, action) => {
	switch(action.type) {
		default:
			return state;
	}
};